import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import ServicesIndexPage from "@/pages/ServicesIndexPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import ScrollToTop from "@/components/ScrollToTop";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { ROUTE_MAP } from "@/i18n/seoMeta";

// Helper to render a service detail route at both CZ and EN paths.
const serviceRoute = (id) => (
  <>
    <Route
      key={`cs-${id}`}
      path={ROUTE_MAP[id].cs}
      element={<ServiceDetailPage serviceId={id} />}
    />
    <Route
      key={`en-${id}`}
      path={ROUTE_MAP[id].en}
      element={<ServiceDetailPage serviceId={id} />}
    />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <LanguageProvider>
          <ScrollToTop />
          <Routes>
            {/* Home — CZ root + EN mirror */}
            <Route path={ROUTE_MAP.home.cs} element={<HomePage />} />
            <Route path={ROUTE_MAP.home.en} element={<HomePage />} />

            {/* Services index — CZ + EN */}
            <Route path={ROUTE_MAP.services.cs} element={<ServicesIndexPage />} />
            <Route path={ROUTE_MAP.services.en} element={<ServicesIndexPage />} />

            {/* Service detail pages (6 IDs × 2 languages = 12 routes) */}
            {serviceRoute("service.mentoring")}
            {serviceRoute("service.consulting")}
            {serviceRoute("service.softSkills")}
            {serviceRoute("service.agile")}
            {serviceRoute("service.okr")}
            {serviceRoute("service.change")}
            {serviceRoute("service.teamDynamics")}
            {serviceRoute("service.collaboration")}

            {/* Fallback to CZ home for unknown routes */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
